import modules from "@/services/utilities/modules";
import {
  getField
} from "vuex-map-fields";

export default {
  getRoot(state) {
    return getField(state);
  },
  isUserType(state) {
    return function (type) {
      return state.user_info.type === type;
    };
  },
  hasPermission(state, getters) {
    return function (module_code, access_name) {
      // if user is superadmin, allow all access
      if (getters.isUserType("superadmin")) {
        return true;
      }

      var module = state.permissions.find(mod => {
        return mod.module_code === module_code;
      });

      if (!module) {
        return false;
      } else {
        return module[access_name + "_access"] == 1;
      }
    };
  },
  // menu items for admin user
  getMenuItems(state) {
    return function () {
      var menu = [];
      state.permissions.forEach(permission => {
        if (permission.parent_code == null && permission.is_menu) {
          // add the modules-routes info to the permission
          var data = modules.get(permission.module_code, permission);

          menu.push(data);
        }
      });
      return menu;
    };
  },
  // Get Modules data
  getModuleData(state) {
    return function (module_code) {
      var module = state.permissions.find(mod => {
        return mod.module_code === module_code;
      });
      var data = modules.get(module_code, module);
      return data;
    };
  }
}
